import { createFileRoute } from '@tanstack/react-router';
import CompanyView from '../../../features/baseData/companies/company/view';
import {
  COMPANIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/firmen/$companyId')({
  component: CompanyView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COMPANIES_PERMISSIONS, 'READ'),
  ),
});

export const ViewCompanyRoute = Route;
